<template>
	<div>
		<div v-if="activeTab === 'invoice'" style="margin-bottom: 10px">
			<van-sticky>
				<van-nav-bar
					right-text="申请开票"
					@click-right="invoice"
				>
					<template #left>
						<van-checkbox v-model="nvaBarState.isSelectAll" checked-color="#ee0a24" style="padding-left: 10px" @click="selectAll">全选</van-checkbox>

					</template>
				</van-nav-bar>
				<div class="nav-bar-plus">
					<div class="nav-bar-span">
						<div class="sub-title">已选</div>
						<div>{{orderCounter}}</div>
					</div>
					<div class="nav-bar-span">
						<div class="sub-title">金额</div>
						<div>{{orderAmount}}</div>
					</div>
					<div class="nav-bar-span">
						<div class="sub-title">开票额度</div>
						<div>{{orderQuota}}</div>
					</div>
				</div>
			</van-sticky>
			<div class="order_list-container">
				<div class="explain">
					1、如想使用充值的开票额度进行开票，可不选择订单直接申请开票。<br>
					2、如想对消费的订单进行开票，请勾选对应的消费订单后再进行申请开票。本功能支持同时对多订单开票。
				</div>
				<van-empty v-if="finished && !orderList.length" description="暂无订单" />
				<van-list
					v-model="listLoading"
					:finished="finished"
					loading-text="..."
					@load="onLoad">
					<div class="order_item-container"
						v-for="(item, index) in orderList"
						:key="'order_item' + index">
						<van-cell @click="selectEvent(index)">
							<van-cell class="order_item-card order_id">
								<template #title>
									<van-checkbox v-model="item.isSelected" checked-color="#ee0a24">{{item.order_no}}</van-checkbox>
								</template>
								<span class="sub-title">{{orderType[item.type]}}</span>
							</van-cell>
							<van-cell class="order_item-card" title="支付方式" :value="$store.state.systemEnum.company.user_order && $store.state.systemEnum.company.user_order.payment_method[item.payment_method]"/>
                            <van-cell class="order_item-card" v-if="item.payment_method === 'combination'" title="组合支付方式" :value="$store.state.systemEnum.company.user_order && $store.state.systemEnum.company.user_order.combination_payment_method[item.combination_payment_method]"/>
							<van-cell class="order_item-card" title="订单时间" :value="item.created_at"/>
							<div class="order_item-checkout">
								<div class="order_item-actual_payment">实付¥{{item.paid_amount}}</div>
							</div>
						</van-cell>
					</div>
				</van-list>
			</div>
		</div>
		<div v-if="activeTab === 'history'" style="margin: 10px 0">
			<van-pull-refresh v-model="historyRefreshLoading" @refresh="onRefresh" class="order_list-container">

				<van-empty v-if="historyFinished && !historyList.length" description="没有开票记录" />
				<van-list
					v-model="historyListLoading"
					:finished="historyFinished"
					loading-text="..."
					@load="onLoadHistory">
					<div class="order_item-container"
						v-for="(item, index) in historyList"
						:key="'order_item' + index">
						<van-cell @click="invoiceDetail(item)">
							<van-cell class="order_item-card order_id" title=" ">
								<template #label>
									<span class="title-sub">{{invoiceType[item.invoice_type]}}</span><br>
									<span class="title">{{item.name}}</span><br>
								</template>
							</van-cell>
							<van-cell v-if="item.invoice_type === 'electron'" class="order_item-card" title="电子票号" :value="item.electron_invoice_no"/>
							<van-cell class="order_item-card" title="状态" :value="invoiceStatusList[item.status]"/>
							<van-cell class="order_item-card" title="开票时间" :value="item.created_at"/>
							<div class="order_item-checkout">
								<div class="order_item-actual_payment">金额¥{{item.total_amount}}</div>
								<van-button v-if="item.invoice_type === 'paper' && item.status == '2'" type="danger" round class="receipt" @click="confirmReceipt(item.id)">确认收货</van-button>
							</div>
						</van-cell>
					</div>
				</van-list>
			</van-pull-refresh>
		</div>
		<van-tabbar v-model="activeTab" placeholder>
			<van-tabbar-item icon="orders-o" name="invoice">发票申请</van-tabbar-item>
			<van-tabbar-item icon="todo-list-o" name="history">开票记录</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
    import api from '../../assets/js/api'
    import CommodityCard from '../../components/beilin/CommodityCard'
	import Auth from  '../../assets/js/auth'

	function accAdd(arg1,arg2){
		var r1,r2,m;
		try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
		try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
		m=Math.pow(10,Math.max(r1,r2));
		return (arg1*m+arg2*m)/m
	}

    export default {
        name: 'OrderList',
        components: {CommodityCard},
        data () {
            return {
				activeTab: 'invoice',
                listLoading: false, // 加载中
                finished: false, // 加载全部完成
				historyRefreshLoading: false,
				historyListLoading: false,
                historyFinished: false,
                orderList: [],
				historyList: [],
                requestIsLock: false, // 请求锁
				_requestIsLock: false,
                params: {
                    page: 1,
                    pageSize: 10
                },
                historyParams: {
                    page: 1,
                    pageSize: 10
                },
				nvaBarState: {
					isSelectAll: false,
				},
				orderType: {
					consume: '消费订单',
					recharge: '充值订单'
				},
				invoiceType: {
					electron: '电子发票',
					paper: '纸质发票'
				},
				invoiceParam: {
					order_no: []
				},
				isLoading: false
            }
        },
		computed: {
			orderCounter() {
				let count = 0;
				for (let item of this.orderList) {
					if (item.isSelected === true) {
						count++
					}
				}
				return count
			},
			orderAmount() {
				let amount = 0;
				for (let item of this.orderList) {
					if (item.isSelected === true && item.paid_amount) {
						amount = accAdd(amount, Number(item.paid_amount))
					}
				}
				return amount
			},
			invoiceStatusList() {
				return this.$store.state.systemEnum.company.user_invoice.status
			},
			isAble() {
				return this.$store.state.systemConfig['invoice.is_electron_invoice_enable'] || this.$store.state.systemConfig['invoice.is_paper_invoice_enable']
			},
			orderQuota() {
				return this.$store.state.userInfo.invoice_quota || 0
			}
		},
		created() {
			this.$store.commit('refreshUserInfo');
			this.getOrderList()
			this.getHistoryList()
		},
        methods: {
            // 列表滚动加载
            onLoad () {
                if (this.requestIsLock) return
                this.getOrderList()
            },

            // 获取订单列表数据
            getOrderList () {
                let loading = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                // 关锁
                this.requestIsLock = true
                api.request('/invoice/order_list', {
                    page: this.params.page,
                    page_size: this.params.pageSize
                }).then(res => {
                    // 如果正在刷新则清空列表，并停止刷新
                    if (this.refreshLoading) {
                        this.orderList = []
                        this.refreshLoading = false
                    }
                    // 数据不为空则页数加一，并添加数据至末尾
                    if (!!res.data.data.length) {
                        this.params.page++
						this.nvaBarState.isSelectAll = false;
                        this.orderList = this.orderList.concat([], res.data.data.map((item) => {
							return {
								...item,
								isSelected: false
							}
						}))
                    }
                    // 判断是否还有数据
                    if (this.orderList.length >= res.data.total) {
                        this.finished = true
                    }
                }).finally(() => {
                    this.listLoading = false
                    this.$toast.clear(loading);
                    // 开锁
                    this.requestIsLock = false
                })
            },

			selectEvent(index) {
				this.orderList[index].isSelected = !this.orderList[index].isSelected;
				for (let item of this.orderList) {
					if (item.isSelected === false) {
						this.nvaBarState.isSelectAll = false;
						return
					}
				}
				this.nvaBarState.isSelectAll = true;
			},

			selectAll() {
				const that = this;
				for (let item of this.orderList) {
					item.isSelected = this.nvaBarState.isSelectAll
				}
			},

			invoice() {
				let order_query = ''
				for (let item of this.orderList) {
					if (item.isSelected === true) {
						this.invoiceParam.order_no.push(item.order_no);
						order_query += `${order_query ? '&' : ''}order_no[]=${item.order_no}`
					}
				}
				if (!this.isAble) {
					this.$dialog.alert({
						message: '本站暂不支持开票',
					})
					return
				}
				this.$router.push({
                    //path: `/${this.$route.params.companyId}/invoice/invoice?${order_query}`
					name: 'Invoice',
					query: this.invoiceParam
                })
			},

            onLoadHistory () {
                if (this._requestIsLock) return
                this.getHistoryList()
            },

            getHistoryList () {
                let loading = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                // 关锁
                this._requestIsLock = true;
                api.request('/invoice/list', {
                    page: this.historyParams.page,
                    page_size: this.historyParams.pageSize
                }).then(res => {
                    // 如果正在刷新则清空列表，并停止刷新
                    if (this.historyRefreshLoading) {
                        this.historyList = []
                        this.historyRefreshLoading = false
                    }
                    // 数据不为空则页数加一，并添加数据至末尾
                    if (!!res.data.data.length) {
                        this.historyParams.page++;
                        this.historyList = [].concat(this.historyList, res.data.data)
                    }
                    // 判断是否还有数据
                    if (this.historyList.length >= res.data.total) {
                        this.historyFinished = true
                    }
                }).finally(() => {
                    this.historyListLoading = false
                    this.$toast.clear(loading);
                    // 开锁
                    this._requestIsLock = false
                })
            },

			onRefresh () {
                if (this._requestIsLock) return
                // 刷新则初始化页数
                this.historyFinished = false
                this.historyRefreshLoading = true;
                this.historyParams.page = 1
                this.getHistoryList()
            },

			invoiceDetail(item) {
				if (item.id) {
					this.$router.push({
                    	path: `/${this.$route.params.companyId}/invoice/invoice_detail?id=${item.id}`
                	})
				}
			},

			confirmReceipt(id) {
				const that = this;
				if(this.isLoading) return;
				this.isLoading = true;
				this.$toast.loading({
                    message: '请求处理中',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/invoice/confirm_receipt', {
                    id: id
                }).then(res => {
					that.$dialog({message: res.msg})
					that.onRefresh()
                }).finally(() => {
                    that.isLoading = false;
                    that.$toast.clear();
                })
			}
        },
    }
</script>

<style lang="scss" scoped>
	.title {
		color: #333;
		font-size: 16px;
	}
	.sub-title {
		color: #bbb;
		font-size: 14px;
		font-weight: lighter;
		padding: 0 0.1rem;
	}

	.nav-bar-plus {
		background: #ffffff;
		line-height: 0.8rem;
		box-sizing: border-box;
		padding: 0 35px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.nav-bar-span {
		flex: 1;
		display: inline-block;
		color: #ee0a24;
		font-size: 14px;
		font-weight: bold;
		margin-right: 0.3rem;
		text-align: center;
	}


    .order_list-container {
        padding: 0 10px;

		.explain {
			margin: 10px 0;
			font-size: 14px;
			color: #999;
			line-height: 22px;

		}

        .order_id {
            font-weight: bold;
            font-size: 16px;
            color: #999;

        }

        .van-pull-refresh {
            overflow: visible;
        }

        .order_item-container {
            margin-top: 10px;
            border-radius: 10px;
            background: #ffffff;
            box-shadow: 0 0 5px 0 rgba(0, 0, 0, .05);
            overflow: hidden;
        }

        .van-cell {
            padding: 10px 20px;
        }

        .order_item-card{
            padding: 0 0 10px;
            margin-bottom: 5px;
            .van-cell__value{
                overflow: visible;
                font-size: 16px;
            }
            &::after {
                left: 0;
                right: 0;
            }
        }

        .order_item-checkout {
            display: flex;
            justify-content: flex-end;
			align-items: center;
			height: 30px;
            font-size: 14px;

            .order_item-total,
            .order_item-discounts {
                margin-right: 5px;
                color: #969799;
            }

            .order_item-actual_payment {
                color: #ee0a24;
                font-weight: bold;
            }

			.receipt {
				height: 100%;
				margin: 0 15px;
			}
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/invoice/InvoiceOrderList.vue